import { bl_fi_entity_hdr_RowClass } from '../../dbschema/bl_fi_mst_entity_hdr.model';
import { BaseContainerModel } from '../base-container.model';
export class EmployeeContainerModel extends BaseContainerModel {
    bl_fi_entity_hdr: bl_fi_entity_hdr_RowClass = new bl_fi_entity_hdr_RowClass();
}
